import { render } from "./LineRib.vue?vue&type=template&id=0cac0747"
import script from "./LineRib.vue?vue&type=script&lang=js"
export * from "./LineRib.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__